<script>
    import NavigationHeader from '../NavigationHeader.vue';
    import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
    import ButtonNormal from '../buttons/ButtonNormal.vue';
    import Modal from '../shared/Modal.vue';
    import FileUploader from '../shared/file-uploader/FileUploader';
    import Accordion from '../shared/Accordion';
    import TariffIndicator from '../shared/TariffIndicator';
    import BusinessHours from './BusinessHours.vue';

    import {BLFgroup} from '@/models/BLFgroup';
    import axios from 'axios';
    import UserService from '@/services/UserService';
    import GroupService from '@/services/GroupService';
    import PhonenumberService from '@/services/PhonenumberService';
    import FaxUserService from '@/services/FaxUserService';
    import SupportUserService from '@/services/SupportUserService';
    import VoicemailboxService from '@/services/VoicemailboxService';
    import SorterService from '@/services/SorterService';
    import NumberPicker from '../shared/NumberPicker.vue';
    import {required} from 'vuelidate/lib/validators';
    import FunctionKeySettingsService from '../../services/FunctionKeySettingsService';
    import {AssignableBLFuser} from '../../models/AssignableBLFuser';
    import { replaceVoicemailAnnouncement } from '@/services/xml-rpc/replaceVoicemailAnnouncementService';
    import { createBusinessHours, getBusinessHours, deleteBusinessHours, updateBusinessHours, toggleBusinessHours } from '@/services/xml-rpc/businessHoursService';
    import utils from '@/services/xml-rpc/utils';
    import { mapGetters } from 'vuex';

    export default {
        name: 'GroupsEdit',
        components: {
            NavigationHeader,
            ButtonIconLeft,
            ButtonNormal,
            Modal,
            NumberPicker,
            FileUploader,
            BusinessHours,
            Accordion,
            TariffIndicator
        },
        data() {
            return {
                id: this.$route.params.id,
                editMode: false,
                isModalForDeleteVisible: false,
                isModalForUpdateVisible: false,
                isSubmitted: false,
                allUsers: [],
                allGroups: [],
                allExternalPhonenumbers: [],
                allInternalPhonenumbers: [],
                internalPhonenumberId: null,
                pickedPhonenumber: null,
                data: {
                    assignableNumbers: [],
                    assignableUsers: [],
                    chatGroup: true,
                    groupId: null,
                    name: '',
                    id: 0,
                    voicemail: true
                },
                voicemailboxNumber: '',
                voicemailboxId: '',
                oldGroupName: '',
                oldAssignableUsers: null,
                title: 'Neue Gruppe erstellen',
                saveButtonTitle: 'Gruppe erstellen',
                mailboxConfig: {
                    title: '',
                    intro: 'Lade hier eine individuelle Mailboxansage für Eure Gruppe im WAV Format hoch! <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Mailboxansagen" target="_blank">Mehr Info</a>',
                    file: {
                        type: '.wav',
                        selected: false
                    },
                    info: {
                        preFileText: '',
                        fileName: '',
                        selectedFile: ''
                    }
                },
                mailboxAudioFile: null,
                businessHoursData: {},
                showBusinessHours: false,
                modules: []
            };
        },
        validations: {
            data: {
                name: {
                    required,
                    uniqueName() {
                        if (this.allGroups.length > 0) {
                            if (this.editMode) {
                                if (this.data.name === this.oldGroupName) {
                                    return true;
                                } else {
                                    for (const entry of this.allGroups) {
                                        if (entry.groupname === this.data.name) {
                                            return false;
                                        }
                                    }
                                    return true;
                                }
                            } else {
                                for (const entry of this.allGroups) {
                                    if (entry.groupname === this.data.name) {
                                        return false;
                                    }
                                }
                                return true;
                            }
                        } else {
                            return true;
                        }
                    },
                },
            }
        },
        created() {
            this.editMode = this.id !== undefined;
            const self = this;
            axios
                .all([
                    PhonenumberService.getAllPhonenumbers(),
                    UserService.getAllUsers(),
                    GroupService.getAllGroups(),
                ])
                .then(
                    axios.spread((phoneNumbers, users, groups) => {
                        if (
                            phoneNumbers.status === 200 &&
                            users.status === 200 &&
                            groups.status === 200
                        ) {
                            self.allUsers = users.data;
                            FaxUserService._removeFaxUserFromList(self.allUsers);
                            SupportUserService._removeSupportUserFromList(self.allUsers);
                            self.allGroups = groups.data;
                            self.getAndSortAllAvailablePhonenumbers(
                                phoneNumbers.data
                            );
                            if (self.editMode) {
                                GroupService.getGroupById(this.id).then(
                                    responseGetGroupById => {
                                        self.data = responseGetGroupById.data;
                                        self.oldGroupName = self.data.name;
                                        SorterService._sortArrayOfStringsByParam(
                                            self.data.assignableUsers,
                                            'lastname'
                                        );
                                        self.fillCurrentExternalPhonenumberInForm();
                                        self.title =
                                            'Gruppe bearbeiten: ' + self.data.name;
                                        self.saveButtonTitle =
                                            'Änderungen speichern';
                                        FaxUserService._removeFaxUserFromAssignableUsersList(
                                            self.data.assignableUsers
                                        );
                                        SupportUserService._removeSupportUserFromAssignableUsersList(
                                            self.data.assignableUsers
                                        );
                                        self.oldAssignableUsers = this.duplicateAssignableUsersList(self.data.assignableUsers);
                                        VoicemailboxService.getAllVoicemailboxes().then(responseGetAllVoicemailboxes => {
                                            if (responseGetAllVoicemailboxes.data && responseGetAllVoicemailboxes.data.length > 0) {
                                                this.getVoicemailboxForGroup(responseGetAllVoicemailboxes.data);
                                            }
                                        });

                                        getBusinessHours(this.getBusinessHoursInstanceName).then( response => {
                                            if (response.data.Success) {
                                                this.setBusinessHoursData(response);
                                                this.showBusinessHours = true;
                                            } else {
                                                this.businessHoursData.INSTANCE_ENABLED = false;
                                                this.showBusinessHours = true;
                                                this.modules.push(this.saveHours());
                                                this.saveModules('', false);
                                            }
                                        });
                                    }
                                );
                            } else {
                                self.createAssignableUsers();
                                self.setDefaultPhonenumber();
                                this.businessHoursData.INSTANCE_ENABLED = false;
                                this.showBusinessHours = true;
                            }
                        }
                    })
                );
        },
        computed: {
            ...mapGetters({
                isPremium: 'isPremium'
            }),
            getBusinessHoursInstanceName() {
                return 'GROUP_' + this.data.id + '_HOURS';
            }
        },
        methods: {
            createAssignableUsers() {
                for (const entry of this.allUsers) {
                    const userData = {
                        assigned: false,
                        firstname: entry.firstName,
                        id: entry.id,
                        lastname: entry.familyName
                    };
                    this.data.assignableUsers.push(userData);
                }
                SorterService._sortArrayOfStringsByParam(
                    this.data.assignableUsers,
                    'lastname'
                );
            },
            closeModalForDelete() {
                this.isModalForDeleteVisible = false;
            },
            confirmModalForDelete() {
                this.isModalForDeleteVisible = false;
                FunctionKeySettingsService.deleteBLFofSpecificGroupforAllUsers(this.oldGroupName, this.oldAssignableUsers);
                GroupService.deleteGroup(this.id)
                    .then(responseDelete => {
                        this.modules.push(this.deleteHours());
                        this.saveModules('Gruppe wurde gelöscht');
                        VoicemailboxService.deleteVoicemailbox(this.voicemailboxId);
                    })
                    .catch(error => {
                        this.showErrorToast('Gruppe konnte nicht gelöscht werden');
                    });
            },
            duplicateAssignableUsersList(userList) {
                const result = [];
                for (const user of userList) {
                    result.push(new AssignableBLFuser(user, false));
                }
                return result;
            },
            closeModalForUpdate() {
                this.isModalForUpdateVisible = false;
            },
            confirmModalForUpdate() {
                this.isModalForUpdateVisible = false;
                this.data.groupId = this.pickedPhonenumber.phoneNumberForLogin;
                if (this.editMode) {
                    this.updateGroup();
                } else {
                    this.createNewGroup();
                }
            },
            setDefaultPhonenumber() {
                for (const entry of this.allExternalPhonenumbers) {
                    if (this.pickedPhonenumber === null && entry.available) {
                        this.pickedPhonenumber = entry;
                        break;
                    }
                }
            },
            getVoicemailboxForGroup(voicemailboxes) {
                for (const voicemailbox of voicemailboxes) {
                    if (voicemailbox.assignedgroups.length > 0 && voicemailbox.assignedgroups[0] === this.data.name) {
                        this.voicemailboxNumber = '*9' + voicemailbox.mailboxnumber;
                        this.voicemailboxId = voicemailbox.id;
                    }
                }
            },
            getAndSortAllAvailablePhonenumbers(responsePhonenumbers) {
                const {
                    external,
                    internal,
                    internalPhoneNumberId
                } = PhonenumberService.splitAndSortNumbersForGroups(
                    responsePhonenumbers,
                    this.internalPhonenumberId
                );
                this.allExternalPhonenumbers = external;
                this.allInternalPhonenumbers = internal;
                if (!this.editMode) {
                    this.internalPhonenumberId = internalPhoneNumberId;
                }
            },
            fillCurrentExternalPhonenumberInForm() {
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (String(phonenumber.assignedGroupAccountId) === this.id) {
                        phonenumber.available = true;
                        this.pickedPhonenumber = phonenumber;
                        break;
                    }
                }
            },
            transformDataForUpdate() {
                const assignableNumbers = [];
                let otherNumberFound = false;
                for (const entry of this.data.assignableNumbers) {
                    if (entry.intern && entry.assigned) {
                        assignableNumbers.push(entry);
                        if (otherNumberFound) {
                            break;
                        }
                        otherNumberFound = true;
                    }
                    if (!entry.intern && entry.id === this.pickedPhonenumber.id) {
                        entry.assigned = true;
                        assignableNumbers.push(entry);
                        if (otherNumberFound) {
                            break;
                        }
                        otherNumberFound = true;
                    }
                }
                this.data.assignableNumbers = assignableNumbers;
            },
            transformDataForCreate() {
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (phonenumber.id === this.pickedPhonenumber.id) {
                        const externalPhonenumber = {
                            assigned: true,
                            countryCode: phonenumber.countryCode,
                            exitCode: phonenumber.exitCode,
                            extension: phonenumber.extension,
                            id: phonenumber.id,
                            intern: false,
                            localAreaCode: phonenumber.localAreaCode
                        };
                        this.data.assignableNumbers.push(externalPhonenumber);
                        break;
                    }
                }
                for (const phonenumber of this.allInternalPhonenumbers) {
                    if (phonenumber.id === this.internalPhonenumberId) {
                        const internalPhonenumber = {
                            assigned: true,
                            countryCode: phonenumber.countryCode,
                            exitCode: phonenumber.exitCode,
                            extension: phonenumber.extension,
                            id: phonenumber.id,
                            intern: true,
                            localAreaCode: phonenumber.localAreaCode
                        };
                        this.data.assignableNumbers.push(internalPhonenumber);
                        break;
                    }
                }
            },
            updateBLFsForGroup() {
                this.deleteBLFforRemovedGroupMembers();
                if (this.oldGroupName !== this.data.name) {
                    FunctionKeySettingsService.updateBLFofSpecificGroupforAllUsers(
                        this.oldGroupName,
                        new BLFgroup(this.data.id, this.data.name),
                        this.oldAssignableUsers);
                }
                this.addBLFforNewGroupMembers();
            },
            deleteBLFforRemovedGroupMembers() {
                for (const oldGroupMember of this.oldAssignableUsers) {
                    if (oldGroupMember.assigned
                        && !this.data.assignableUsers.filter(currentGroupMember => currentGroupMember.id === oldGroupMember.id)[0].assigned) {
                        oldGroupMember.blfWillBeRemoved = true;
                        FunctionKeySettingsService.getAllFunctionKeySettingsForUser(oldGroupMember.id)
                            .then(userKeys => {
                                const functionKeyId = userKeys.data.filter(key => key.functionKeyType === 'GROUPLOGIN' && key.name === this.oldGroupName)[0].id;
                                FunctionKeySettingsService.deleteBLFforSpecificUser(oldGroupMember.id, functionKeyId);
                            });
                    }
                }
            },
            addBLFforNewGroupMembers() {
                for (const currentGroupMember of this.data.assignableUsers) {
                    if (currentGroupMember.assigned
                        && !this.oldAssignableUsers.filter(oldGroupMembers => oldGroupMembers.id === currentGroupMember.id)[0].assigned) {
                        FunctionKeySettingsService.setBLFforSpecificGroup(currentGroupMember.id, new BLFgroup(this.data.id, this.data.name));
                    }
                }
            },
            createNewGroup() {
                this.transformDataForCreate();
                GroupService.createGroup(this.data)
                    .then(responseCreate => {
                    GroupService.getAllGroups()
                        .then(responseGetAllGroups => {
                            this.extractAndSetGroupId(responseGetAllGroups, this.data.name);
                            FunctionKeySettingsService.setBLFforSpecificGroupForAllUsers(this.data.name, this.data.assignableUsers);
                        });
                    VoicemailboxService.getAllVoicemailboxes().then(responseGetAllVoicemailboxes => {
                        if (responseGetAllVoicemailboxes.data && responseGetAllVoicemailboxes.data.length > 0) {
                            this.getVoicemailboxForGroup(responseGetAllVoicemailboxes.data);
                            this.mailboxAudioFile ? this.modules.push(this.saveMailboxAnsage()) : '';
                            this.modules.push(this.saveHours());
                            this.saveModules('Gruppe erfolgreich hinzugefügt');
                        }
                    });
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Gruppe konnte nicht erstellt werden',
                            icon: 'GROUP'
                        });
                    });
            },
            extractAndSetGroupId(groups, groupName) {
                groups.data.forEach( group => {
                    if (group.groupname === groupName) {
                        this.data.id = group.id;
                    }
                });
            },
            updateGroup() {
                this.transformDataForUpdate();
                GroupService.updateGroup(this.data)
                    .then(responseUpdate => {
                        this.updateBLFsForGroup();
                        this.mailboxAudioFile ? this.modules.push(this.saveMailboxAnsage()) : '';
                        this.modules.push(this.updateHours());
                        this.saveModules('Änderungen gespeichert');
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Gruppe konnte nicht aktualisiert werden',
                            icon: 'GROUP'
                        });
                    });
            },
            saveGroup() {
                this.isSubmitted = true;
                if (!this.$v.data.$invalid) {
                    if (this.editMode) {
                        this.isModalForUpdateVisible = true;
                    } else {
                        this.confirmModalForUpdate();
                    }
                } else {
                    this.$toasted.global.starface_error({
                        message: 'Bitte gebe einen einzigartigen Gruppennamen ein.',
                        icon: 'GROUP'
                    });
                }
            },
            deleteGroup() {
                this.isModalForDeleteVisible = true;
            },
            setBusinessHoursData(dataFromModule) {
                this.businessHoursData.GUI_ZEITRAEUME_DER_UMLEITUNG = dataFromModule.data.Params.GUI_ZEITRAEUME_DER_UMLEITUNG;
                this.businessHoursData.INSTANCE_ENABLED = dataFromModule.data.Params.INSTANCE_ENABLED;
                this.businessHoursData.GUI_ANSAGE = dataFromModule.data.Params.GUI_ANSAGE;
            },
            uploadMailboxFile(event) {
                const file = event.target.files[0];
                if (file) {
                    this.mailboxConfig.file.selected = true;
                    this.mailboxConfig.info.selectedFile = file.name;
                    utils.getBase64(file).then(
                        data => {
                            this.mailboxAudioFile = data;
                        }
                    );
                }
            },
            saveMailboxAnsage() {
                if (this.mailboxAudioFile) {
                    return replaceVoicemailAnnouncement({mailbox: this.voicemailboxNumber, audio: this.mailboxAudioFile}).then( response => {
                        if (response.data.Success) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                } else {
                    this.showSuccessToastAndNavigate(message);
                    return false;
                }
            },
            saveHours() {
                this.businessHoursData.GUI_UMLEITUNG_FUER = this.pickedPhonenumber.phoneNumberComplete;
                return createBusinessHours(this.getBusinessHoursInstanceName, this.businessHoursData).then( response => {
                    if (response.data.Success) {
                        toggleBusinessHours(this.getBusinessHoursInstanceName, this.businessHoursData.INSTANCE_ENABLED);
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            updateHours() {
                this.businessHoursData.GUI_UMLEITUNG_FUER = this.pickedPhonenumber.phoneNumberComplete;
                return updateBusinessHours(this.getBusinessHoursInstanceName, this.businessHoursData).then( response => {
                    if (response.data.Success) {
                        toggleBusinessHours(this.getBusinessHoursInstanceName, this.businessHoursData.INSTANCE_ENABLED);
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            deleteHours() {
                return deleteBusinessHours(this.getBusinessHoursInstanceName).then( response => {
                    if (response.data.Success) {
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            async saveModules(message, navigate = true) {
                const arrayOfAllResponses = [] = await Promise.all(this.modules);
                if (this.checkIfModulesEndopintsPassed(arrayOfAllResponses)) {
                    this.showSuccessToastAndNavigate(message, navigate);
                } else {
                    this.showErrorToast('Something went wrong upon module save');
                }
                this.modules = [];
            },
            checkIfModulesEndopintsPassed(arrayOfAllResponses) {
                return arrayOfAllResponses.every( response => response === arrayOfAllResponses[0] );
            },
            showSuccessToastAndNavigate(message, navigate) {
                message ? this.$toasted.global.starface_success({message: `${message}`, icon: 'GROUP'}) : '';
                if (navigate) {
                    this.$router.push('/groups');
                }
            },
            showErrorToast(message) {
                message ? this.$toasted.global.starface_error({message: `${message}`, icon: 'GROUP'}) : '';
            },
            onChildUpdate(data) {
                this.businessHoursData.GUI_ZEITRAEUME_DER_UMLEITUNG = data.times;
                this.businessHoursData.GUI_ANSAGE = data.audio;
                this.businessHoursData.INSTANCE_ENABLED = data.status;
            }
        }
    };
</script>

<template>
    <div class="container">
        <div id="group-edit">
            <NavigationHeader route="/groups" navigationText="zurück zur Übersicht" :title="title"/>
            <div class="wrapper">
                <div class="description">
                    Füge Mitglieder zu der Gruppe hinzu und weise ihr eine Rufnummer zu.
                </div>
                <form class="form">
                    <div class="form-group form-text groupName">
                        <label for="name">Gruppenname</label>
                        <input class="form-control" type="text" name="name" id="name" v-model="data.name"
                               v-bind:class="{ 'has-error': isSubmitted && $v.data.name.$invalid }"
                               @input="$v.data.name.$touch()" required/>
                        <span class="error-message" v-if="isSubmitted && $v.data.name.$invalid">Bitte gebe einen einzigartigen Gruppennamen ein.</span>
                    </div>
                    <div class="users">Benutzer innerhalb der Gruppe</div>
                    <div class="checkbox-wrapper">
                        <div class="form-group form-check" v-for="entry in data.assignableUsers" :key="entry.id">
                            <input class="form-check-input" type="checkbox" :name="entry.id" :id="entry.id"
                                   v-model="entry.assigned">
                            <label class="form-check-label" :for="entry.id">
                                <span class="name">{{entry.lastname}}, {{entry.firstname}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="phone-numbers">
                        <div class="title">Rufnummer der Gruppe</div>
                        <NumberPicker v-if="pickedPhonenumber" :numbers="allExternalPhonenumbers" :max-height="'200px'"
                                      :columns="4" :defaultValue="pickedPhonenumber" v-model="pickedPhonenumber"/>
                    </div>
                    <div v-if="editMode" class="voicemailbox-number">
                        <div class="title">Voicemailbox der Gruppe</div>
                        <div>{{voicemailboxNumber}}</div>
                    </div>
                </form>
                <TariffIndicator title="Weitere Funktionen" :show="!isPremium"/>
                <Accordion title="Mailboxansage" :disabled="!isPremium">
                <FileUploader :config="mailboxConfig" @uploadFile="uploadMailboxFile"/>
                </Accordion>
                <Accordion title="Geschäftszeitenregelung" :disabled="!isPremium">
                <BusinessHours v-if="showBusinessHours" :moduleData="businessHoursData" @sendBusinessHoursData="onChildUpdate"/>
                </Accordion>
                <div class="footer">
                    <div class="left">
                        <ButtonIconLeft v-if="editMode" class="btn-delete" @onClick="deleteGroup"
                                        buttonTitle="Gruppe löschen" src="delete" cssClass="btn btn-tertiary"/>
                    </div>
                    <div class="right">
                        <ButtonNormal @onClick="$router.push('/groups')" class="btn-cancel" buttonTitle="Abbrechen"
                                      cssClass="btn btn-secondary"/>
                        <ButtonNormal @onClick="saveGroup" class="btn-save" :buttonTitle="saveButtonTitle"
                                      cssClass="btn btn-primary"/>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="isModalForUpdateVisible" @close="closeModalForUpdate"
               @confirm="confirmModalForUpdate" confirmationButtonText="Speichern">
            <template slot="header">
                Möchtest Du die Änderungen wirklich speichern?
            </template>
        </Modal>
        <Modal v-show="isModalForDeleteVisible" :is-red="true" @close="closeModalForDelete"
               @confirm="confirmModalForDelete">
            <template slot="header">
                Möchtest Du die Gruppe {{this.data.name}} wirklich löschen?
            </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/buttons.scss';
    @import '../../assets/scss/general.scss';
    @import '../../assets/scss/forms.scss';
    @import '../../assets/scss/inputs.scss';
    @import '../../assets/scss/grid.scss';

    #group-edit {
        .wrapper {
            .description {
                padding-bottom: 32px;
            }

            form {
                .users {
                    font-size: 28px;
                }

                .checkbox-wrapper {
                    padding-top: 10px;
                }

                .phone-numbers, .voicemailbox-number {
                    margin: 50px auto;

                    .title {
                        font-weight: bold;
                        margin-bottom: 12px;
                    }
                }

                .error-message {
                    font-size: 12px;
                    font-weight: 600;
                    text-align: left;
                    color: $red;
                }

                .has-error {
                    border-color: #f54d00;
                }
            }

            .footer {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 25px;

                .left {
                    display: flex;
                }

                .right {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .btn-cancel {
                        margin-right: 20px;
                        margin-bottom: 20px;
                    }

                    .btn-save {
                        height: 48px;
                        width: 240px;
                        border-radius: 2px;
                        border: 2px solid $orange;
                        background-color: $orange;
                        color: white;
                        font-size: 16px;
                    }
                }
            }
        }
    }
</style>
